// extracted by mini-css-extract-plugin
export default {"root":"YO572Z","catalogSelect":"qSnxuT","form":"zNCCU2","inputHolder":"i2LSBp","input":"lsZsBN","submit":"fgtavF","icon":"t9wA7M"};